// @flow

import window from 'window';

export class PostscribeCssBundle {
	static push = (path: string, name: string) => {
		return new Promise((resolve, reject): Promise => {
			const head = window.document.getElementsByTagName('head')[0];
	
			const element = window.document.createElement('link');
			element.setAttribute('href', path);
			element.setAttribute('type', 'text/css');
			element.setAttribute('rel', 'stylesheet');
			head.appendChild(element);

			element.onload = () => {
				resolve();
			};

			element.onerror = () => {
				reject(new Error(`file [${name}] doesn't exists or invalid url`));
			};
		});
	};

	static exists = (url: string): boolean => {
		return Boolean(window.document.querySelectorAll(`link[href="${url}"]`).length);
	};
}